import { DataConnection } from "@encoo-web/encoo-ui";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DataConnectionEntityModel = createEntityModel<DataConnection>();
